module.exports = __webpack_public_path__ + "static/img/voice.097a4acb.png";